import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Tab } from "@pentabd/ui";

import Priority from "./Priority";
// import Status from "./Status";
import TicketCategory from "./TicketCategory";
import TicketType from "./TicketType";

export const TicketSettingsBody = () => {
  const [activeTab, setActiveTab] = useState(0);

  const { t } = useTranslation();

  const tabData = [
    // {
    //   label: t("TICKETS.SETTINGS.TAB.STATUS.LABEL"),
    //   component: <Status />,
    // },
    {
      label: t("TICKETS.SETTINGS.TAB.PRIORITY.LABEL"),
      component: <Priority />,
    },
    {
      label: t("TICKETS.SETTINGS.TAB.CATEGORY.LABEL"),
      component: <TicketCategory />,
    },
    {
      label: t("TICKETS.SETTINGS.TAB.TYPE.LABEL"),
      component: <TicketType />,
    },
  ];

  return (
    <div className="pt-10">
      <Tab active={activeTab} setActiveTab={setActiveTab}>
        <Tab.Heads>
          {tabData.map(({ label }, i) => (
            <Tab.Item key={i} index={i} label={label} />
          ))}
        </Tab.Heads>
        <Tab.ContentWrapper>
          {tabData.map(({ component }, i) => (
            <Tab.Content key={i} index={i}>
              {component}
            </Tab.Content>
          ))}
        </Tab.ContentWrapper>
      </Tab>
    </div>
  );
};
